import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsItFor() {
  const forYou = ['Dueños de gatos que aman a su mascota pero están al límite del colapso por el olor.', 'Personas que se mudaron hace poco y su gato empezó a orinar fuera de la caja.', 'Multihogares (más de un gato) donde hay tensión territorial.', 'Cualquier persona que esté cansada de tirar plata en productos que no sirven.'];
  const notForYou = ['Personas que buscan soluciones mágicas sin mover una caja de lugar.', 'Dueños que creen que el castigo físico es la solución.', 'Gatos con obstrucciones urinarias (eso requiere un veterinario urgente).'];
  return <section className="w-full bg-white py-6 md:py-20 px-4 md:px-6" data-id="element-456">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto" data-id="element-457">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-6 md:mb-12 text-center" data-id="element-458">
          ¿Es para vos?
        </h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-459">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#E8F0E8] p-5 md:p-8 rounded-lg" data-id="element-460">
            <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#2D8C5A] mb-4 md:mb-6" data-id="element-461">
              Para vos si:
            </h3>
            <div className="space-y-4" data-id="element-462">
              {forYou.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-463">
                  <CheckCircleIcon className="w-6 h-6 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-464" />
                  <p className="text-[#1C1C1C]" data-id="element-465">{item}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#FAFAF7] p-5 md:p-8 rounded-lg border-2 border-[#8B4513]/20" data-id="element-466">
            <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#8B4513] mb-4 md:mb-6" data-id="element-467">
              No es para vos si:
            </h3>
            <div className="space-y-4" data-id="element-468">
              {notForYou.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-469">
                  <XCircleIcon className="w-6 h-6 text-[#8B4513] flex-shrink-0 mt-0.5" data-id="element-470" />
                  <p className="text-[#1C1C1C]" data-id="element-471">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}